import React, { useState } from 'react';
import '../styles/Navbar.css';
const logo = './logo.png';

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav className="navbar">
            <div className="left">
                <a href="/">
                    <img src={logo} alt="Logo" className="logo" />
                </a>

                <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                    <i className={menuOpen ? "fas fa-times" : "fas fa-bars"}></i>
                </div>

                <ul className={menuOpen ? "nav-links active" : "nav-links"}>
                    <li><a href="#about">Hakkımızda</a></li>
                    <li><a href="#services">Hizmetler</a></li>
                    <li><a href="#contact">İletişim</a></li>
                </ul>
            </div>

            <div className="contact-buttons">
                <a href="tel:+905514978161" className="call-btn">
                    <i className="fas fa-phone-alt"></i> Bizi Arayın
                </a>
                <a href="https://wa.me/905514978161" className="call-btn">
                    <i className="fab fa-whatsapp"></i> WhatsApp
                </a>
            </div>
        </nav>
    );
}

export default Navbar;
